export function getEnumsLabel(enumItem, key) {
  let data = enums[enumItem];
  if (data == undefined) {
    // console.error("枚举类型不存在");
    return "";
  }
  let itemData = data.filter(item => item.value == key)[0];
  if (itemData == undefined) {
    // console.error("枚举类型键值不存在:" + enumItem + "-" + key);
    return "";
  }
  // console.log(itemData, enumItem, key);
  return itemData.text;
}

export let enums = {
  DEVICESTATUS: [
    //设备在线状态
    {
      value: 0,
      text: "离线"
    },
    {
      value: 1,
      text: "在线"
    },
    {
      value: 2,
      text: "脱机"
    },
    {
      value: 3,
      text: "开机中"
    },
    {
      value: 4,
      text: "关机中"
    }
  ],
  AIRPORTSTATUS: [
    //机场状态
    {
      value: -1,
      text: "离线"
    },
    {
      value: 0,
      text: "空闲中"
    },
    {
      value: 1,
      text: "现场调试"
    },
    {
      value: 2,
      text: "远程调试"
    },
    {
      value: 3,
      text: "固件升级中"
    },
    {
      value: 4,
      text: "作业中"
    }
  ],
  DRONEWORKSTATUS: [
    //无人机状态
    {
      value: 0,
      text: "待机"
    },
    {
      value: 1,
      text: "起飞准备"
    },
    {
      value: 2,
      text: "起飞准备完毕"
    },
    {
      value: 3,
      text: "手动飞行"
    },
    {
      value: 4,
      text: "自动起飞"
    },
    {
      value: 5,
      text: "航线飞行"
    },
    {
      value: 6,
      text: "全景拍照"
    },
    {
      value: 7,
      text: "智能跟随"
    },
    {
      value: 8,
      text: "ADS-B 躲避"
    },
    {
      value: 9,
      text: "自动返航"
    },
    {
      value: 10,
      text: "自动降落"
    },
    {
      value: 11,
      text: "强制降落"
    },
    {
      value: 12,
      text: "三桨叶降落"
    },
    {
      value: 13,
      text: "升级中"
    },
    {
      value: 14,
      text: "未连接"
    },
    {
      value: 15,
      text: "辅助飞行功能 - APAS"
    },
    {
      value: 16,
      text: "虚拟摇杆"
    },
    {
      value: -1,
      text: "舱内关机"
    }
  ],
  COVERSTATUS: [
    //舱盖状态
    {
      value: 0,
      text: "关闭"
    },
    {
      value: 1,
      text: "打开"
    },
    {
      value: 2,
      text: "半开"
    },
    {
      value: 3,
      text: "舱盖状态异常"
    },
    {
      value: 4,
      text: "开启中..."
    },
    {
      value: 5,
      text: "关闭中..."
    }
  ],
  DRONEDOCKSTATUS: [
    //	飞机是否在舱
    {
      value: 0,
      text: "舱外"
    },
    {
      value: 1,
      text: "舱内"
    }
  ],
  PUTTERSTATUS: [
    //	推杆状态
    {
      value: 0,
      text: "关闭"
    },
    {
      value: 1,
      text: "打开"
    },
    {
      value: 2,
      text: "半开"
    },
    {
      value: 3,
      text: "推杆状态异常"
    },
    {
      value: 4,
      text: "推杆展开中"
    },
    {
      value: 5,
      text: "推杆展关闭中"
    }
  ],
  CHARGESTATUS: [
    //	充电状态
    {
      value: 0,
      text: "空闲"
    },
    {
      value: 1,
      text: "充电中"
    }
  ],
  COMMANDSTATUS: [
    //	命令执行状态
    {
      value: "send",
      text: "已下发"
    },
    {
      value: "in_progress",
      text: "执行中"
    },
    {
      value: "ok",
      text: "执行成功"
    },
    {
      value: "paused",
      text: "暂停"
    },
    {
      value: "rejected",
      text: "拒绝"
    },
    {
      value: "failed",
      text: "失败"
    },
    {
      value: "canceled",
      text: "取消或终止"
    },
    {
      value: "timeout",
      text: "超时"
    }
  ]
};

export default {
  getEnumsLabel
};



// WEBPACK FOOTER //
// ./src/js/enums.js